import React from "react";
import ScfoButton from "../ScfoButton";

/**
 * Standard modal action row: optional left slot (e.g. totals), cancel + confirm.
 * Confirm uses async click guard by default to match previous AsyncButton behavior.
 *
 * Form field look (labels, inputs, section titles): global partial `src/scss/_scfo-modal-form.scss`.
 * Optional helpers: `src/components/shared/modalFormButtons` (ModalDismissButton, etc.).
 */
export default function ModalActionsFooter({
  className = "",
  left = null,
  cancelLabel = "Cancelar",
  onCancel,
  confirmLabel,
  onConfirm,
  confirmDisabled = false,
  confirmLoading = false,
  confirmVariant = "primary",
  cancelVariant = "ghost",
  confirmAsync = true,
}) {
  return (
    <div
      className={`tw-flex tw-justify-between tw-items-center tw-w-full tw-gap-3 tw-flex-wrap ${className}`.trim()}
    >
      <div className="tw-min-w-0">{left}</div>
      <div className="tw-flex tw-gap-2 tw-items-center tw-ml-auto">
        {onCancel ? (
          <ScfoButton type="button" variant={cancelVariant} onClick={onCancel}>
            {cancelLabel}
          </ScfoButton>
        ) : null}
        {confirmLabel && onConfirm ? (
          <ScfoButton
            type="button"
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={confirmDisabled}
            loading={confirmLoading}
            async={confirmAsync}
          >
            {confirmLabel}
          </ScfoButton>
        ) : null}
      </div>
    </div>
  );
}
